const semanticTokens = {
  colors: {
    'surface.default': '#ffffff',
    'surface.muted': 'brand.50',
    'surface.blue': 'brand.100',
    'surface.inverse': 'brand.900',
    'text.primary': '#10233f',
    'text.secondary': '#53657d',
    'text.inverse': '#ffffff',
    'border.default': '#dce5ef',
    'border.strong': '#c5d2e0',
    'accent.default': 'brand.600',
    'accent.hover': 'brand.700',
    'accent.active': 'brand.800',
  },
};

export default semanticTokens;
